module.exports = __webpack_public_path__ + "img/service-content-money-excel@3x.5fb628e5.png";